import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'risk_form_answers'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'Inmueble' },
  SECTOR: {},
  CENTER: {},
  MUNICIPALITY: {},
  STATUS: { column: 'risk_evaluation_status_catalog.name', label: 'Estatus' },
  REGION: false,
  TENANT: false,
  USER: {},
})

export default {
  key: DATASET_KEY,
  label: 'Proced. Op. - Evaluación de Riesgo',
  timeColumn: 'risk_form_answers.created_at',
  permission: { action: 'read', subject: 'RiskEvaluation' },

  tables: {
    risk_form_answers: ["id", "uuid", "name", "data", "id_template", "id_risk_evaluation", "risk_percentage", "created_at", "updated_at", "template_snapshot", "template_sources"],
    risk_evaluations: ["id", "reference_number", "id_unit", "id_user", "evaluation_date", "created_at", "updated_at", "flagged_comments", "reviewed_residual_risk", "executive_resume"],
    risk_templates: ["id", "uuid", "name", "data", "id_tenant", "id_user", "created_at", "updated_at"],
    risk_evaluation_status_catalog: ["id", "name", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    municipalities: [],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
  },

  // The evaluation's status comes from its history (one row per change). See
  // useCurrentStatus.
  currentStatus: {
    recordColumn: 'risk_evaluations.id',
    historyColumn: 'risk_evaluation_status.id',
    tables: ['risk_evaluation_status', 'risk_evaluation_status_catalog'],
  },

  // «Solo abiertos»: records whose current status is one of these are left
  // out. See useCurrentStatus.
  closedStatus: {
    column: 'risk_evaluation_status_catalog.name',
    values: ['approved', 'canceled'],
  },

  analysisConfig: {
    byField: 'units.description',
    dataColumn: 'risk_form_answers.data',
  },

  csvConfig: {
    withTables: 'risk_form_answers',
    columns: 'risk_evaluations.reference_number,risk_evaluations.created_at,risk_templates.name,risk_evaluation_status_catalog.name,users.user,users.name,users.email,units.description,municipalities.name,centers.name',
    exceptColumns: 'risk_form_answers.name,risk_templates.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'data', label: 'Eval. de riesgo - Cuestionarios', processForm: true },
    { key: 'units.description', label: 'Inmueble' },
    { key: 'users.name', label: 'Usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'risk_evaluation_status_catalog.name', label: 'Estatus' },
    { key: 'risk_form_answers.risk_percentage', label: 'Nivel' },
    { key: 'risk_form_answers.created_at', label: 'Fecha de creacion', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    ...commonFilters,
    {
      key: 'question',
      label: 'Preguntas del formulario',
      forField: 'Preguntas del formulario',
      filterType: 'process-form',
      optionsConfig: {
        type: 'json-keys',
        dataset: 'risk_form_answers',
        column: 'risk_form_answers.data',
        limit: -1,
      },
    },
    //embedFilter(DATASET_KEY, 'risk_form_answers.risk_percentage', 'Nivel', 'level'),
  ],

  dateGrouping: {
    column: 'risk_form_answers.created_at',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
